import React,{useState,useEffect} from 'react';
import {useHistory,useLocation} from 'react-router-dom';
import styled from 'styled-components';
import {motion} from 'framer-motion';
import home from '../assets/img/home.jpg';
import bp1 from '../assets/img/bp1.jpg'
import bp2 from '../assets/img/bp2.jpg'
import bp3 from '../assets/img/bp3.jpg'
import bp4 from '../assets/img/bp4.jpg'
import bp5 from '../assets/img/bp5.jpg'
import ty from '../assets/img/thankyou.jpg'
import lg from '../assets/img/a-icon.svg';
import HomeIcon from '../assets/img/home-icon.svg';
import {isMobile} from 'react-device-detect';

const Panel = ({children,w,setBG}) => {

    const history = useHistory();
    const location = useLocation();
    const [panelBG,setPanelBG] = useState();

    useEffect(() =>{
        switch (setBG){
            case 'home':
                setPanelBG(home);
                break;
            case 'bp1':
                setPanelBG(bp1);
                break;
            case 'bp2':
                setPanelBG(bp2);
                break;
            case 'bp3':
                setPanelBG(bp3);
                break;
            case 'bp4':
                setPanelBG(bp4);
                break;
            case 'bp5':
                setPanelBG(bp5);
                break;
            case 'ty':
                setPanelBG(ty);
                break;
            default:
                break;
        }
    },[])

    

    const bg = {
        backgroundImage: 'url(' + panelBG + ')',
    }

    return(
        <ThePanel initial={isMobile ? {opacity:0} : {y:'-100%'}} animate={isMobile ? {opacity:1,transition:{duration:.5}} : {y:0,transition:{duration:1}}} exit={isMobile ? {opacity:1,transition:{duration:.5}} : {y:'100%',transition:{duration:1}}} style={bg} className={w === 50 ? 'half' : null}>
            <MobileLogo className={location.pathname == '/' ? 'isHome' : null} />
            <HomeButton className={location.pathname == '/' ? 'isHome' : null} onClick={()=>{history.push('/')}}/> 
            {children}
        </ThePanel>
    )

}

const ThePanel = styled(motion.div)`
    background: #333147;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 30%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'MarkPro-Black';
    font-size: 3em;
    text-align: center;
    position: relative;
    z-index: 4;
    overflow: hidden !important;

    @media (max-width: 1060px) {
        width: 100%;
        height: 230px;

        .process-title{
            margin-top: 55px;
        }
    }

    div{
        max-width: 60%;

        @media (max-width: 1060px) {
           text-align: center;
           max-width: 75%;
        }

        &:last-of-type{
            @media (max-width: 1060px) {
                /* margin-top: 55px; */
                line-height: 1;
            } 
        }
    }

    &.half{
        width: 50%;
        font-size: unset;
        overflow: unset !important;

        @media (max-width: 1060px) {
           width: 100%;
           height: 300px;
        }


        &::after{
            background: rgba(0,0,0,.3);
        }
    }

    &::after{
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(236,0,140,.5);
        z-index: -1;
    }
`;


const MobileLogo = styled.div`
    display: none;


    @media (max-width: 1060px) {
           display: block;
           position: absolute;
           top: 20px;
           right: 20px;
           background: url(${lg}) no-repeat center center;
           background-size: cover;
           width: 67px;
            height: 50px;

            /* &.isHome{
                width: 54px;
                height: 40px;
            } */
        }
`;

const HomeButton = styled.div`
    display: block;
    width: 70px; 
    height: 70px;
    border-radius: 100px;
    position: absolute;
    top: 20px;
    left: 20px;
    background: url(${HomeIcon}) no-repeat center center;
    background-size: 60%;
    background-color: #333147;
    cursor: pointer;

    @media (max-width: 1060px) {
        width: 62px;
        height: 62px;
    }

    &.isHome{
        display: none;
    }

`;

export default Panel;